import React from 'react';

const COPY = {
  en: {
    title: 'About you',
    nameLabel: 'Display name',
    namePlaceholder: 'Your display name',
    bioLabel: 'Bio',
    bioPlaceholder: 'A short intro about you — or leave blank',
  },
  zh: {
    title: '个人简介',
    nameLabel: '显示名称',
    namePlaceholder: '你的显示名称',
    bioLabel: '简介',
    bioPlaceholder: '写一句介绍自己，或留空',
  },
};

function AboutIcon() {
  return (
    <svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true" fill="none">
      <circle cx="10" cy="7" r="3.5" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M4 17c0-3.3 2.7-6 6-6s6 2.7 6 6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

function ProfileAboutCard({
  lang,
  name,
  bio,
  nameError,
  onNameChange,
  onBioChange,
  animationDelay = 0,
}) {
  const t = COPY[lang === 'zh' ? 'zh' : 'en'];
  const nameLen = String(name || '').length;
  const bioLen = String(bio || '').length;

  return (
    <section
      className="profile-v2-panel profile-v2-about profile-v2-enter"
      style={{ animationDelay: `${animationDelay}ms` }}
    >
      <header className="profile-v2-panel-head">
        <span className="profile-v2-panel-badge" aria-hidden="true">
          <AboutIcon />
        </span>
        <div className="profile-v2-panel-head-text">
          <h2 className="profile-v2-panel-title">{t.title}</h2>
          <p className="profile-v2-panel-subtitle">
            {lang === 'zh' ? '对外展示的名称与一句话介绍' : 'How others see you on Aevdir'}
          </p>
        </div>
      </header>

      <div className="profile-v2-form-stack">
        <label className="profile-v2-field">
          <div className="profile-v2-field-head">
            <span className="profile-v2-field-label">{t.nameLabel}</span>
            <span className="profile-v2-char-count">{nameLen}/50</span>
          </div>
          <div className={`profile-v2-input-shell${nameError ? ' is-invalid' : ''}`}>
            <input
              value={name}
              onChange={(e) => onNameChange(e.target.value)}
              placeholder={t.namePlaceholder}
              minLength={3}
              maxLength={50}
              required
            />
          </div>
        </label>
        {nameError ? <p className="form-error profile-v2-field-error">{nameError}</p> : null}

        <label className="profile-v2-field">
          <div className="profile-v2-field-head">
            <span className="profile-v2-field-label">{t.bioLabel}</span>
            <span className="profile-v2-char-count">{bioLen}/500</span>
          </div>
          <div className="profile-v2-input-shell profile-v2-input-shell-area">
            <textarea
              className="profile-v2-textarea"
              value={bio}
              onChange={(e) => onBioChange(e.target.value)}
              placeholder={t.bioPlaceholder}
              rows={4}
              maxLength={500}
            />
          </div>
        </label>
      </div>
    </section>
  );
}

export default ProfileAboutCard;
